export default __webpack_public_path__ + "static/reviews-video-chris-b5bed22b6d8f38299b4c0d59e534495a.png";